export class Profile{
  constructor(
    public uid: string,
    public name: string,
    public short_name: string,
    public registration_date: string,
    public type: {
      value: string,
      avilable_offers: number,
      pakege?: string,
      avilable_special?: any[]
      expired_date?: any,
      order_id?: string,
    },
    public status: string,
    public login_method: string,
    public num_offers: number,
    public img_url?: string,
    public bio?: string,
    public email?: string,
    public phone?: any,
    public phone2?: any,
    public coordinates?: any,
    public country?: string,
    public notification_token?: string
  ){}
}
